import { Shadow, SkeletonTypes, HStack, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

export const CardLoadingItemTablet: React.FC = () => {
  const ColoredSkeleton = (props: SkeletonTypes.Props) => (
    <Skeleton {...props} endColor="brand.primary.lightest" />
  );

  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy} p={Spacing['inset.sm']}>
      <VStack space={Spacing['stack.xxxs']}>
        <HStack justifyContent="space-between" space={Spacing['inline.quarck']}>
          <VStack
            justifyContent="space-between"
            alignContent="center"
            space={Spacing['inline.quarck']}
            minW={120}>
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
          </VStack>

          <VStack
            justifyContent="space-between"
            alignContent="center"
            space={Spacing['inline.quarck']}
            minW={120}>
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
          </VStack>

          <VStack
            justifyContent="space-between"
            alignContent="center"
            space={Spacing['inline.quarck']}
            minW={120}>
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
          </VStack>

          <VStack
            justifyContent="space-between"
            alignContent="center"
            space={Spacing['inline.quarck']}
            minW={120}>
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
            <ColoredSkeleton width="80%" height="20px" rounded="full" />
          </VStack>
        </HStack>
      </VStack>
    </Shadow>
  );
};
